(() => {
  if (window.__NT_CART_GIFT_LOADED__) return;
  window.__NT_CART_GIFT_LOADED__ = true;

  let enforcementRunning = false;


  const getDrawer = () =>
    document.querySelector('cart-drawer');


  function setGiftButtonState(button, loading, text) {
    if (!button) return;

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.innerHTML;
    }

    button.disabled = loading;

    if (text) {
      button.textContent = text;
    } else if (!loading) {
      button.innerHTML = button.dataset.originalText;
    }
  }


  async function addFreeGift(button) {
    const card =
      button.closest('[data-nt-gift-card]');

    if (!card) return;


    const select =
      card.querySelector('[data-nt-gift-variant]');

    const variantId =
      select?.value;

    if (!variantId) return;


    setGiftButtonState(
      button,
      true,
      'Wird hinzugefügt…'
    );


    try {
      const drawer = getDrawer();

      const config =
        fetchConfig('javascript');

      config.headers['X-Requested-With'] =
        'XMLHttpRequest';

      delete config.headers['Content-Type'];


      const formData =
        new FormData();

      formData.append(
        'id',
        variantId
      );

      formData.append(
        'quantity',
        '1'
      );

      /*
       * Versteckte Line-Item-Property.
       * Damit erkennen wir das Geschenk später.
       */
      formData.append(
        'properties[_nt_free_gift]',
        'true'
      );


      if (
        drawer &&
        typeof drawer.getSectionsToRender === 'function'
      ) {
        formData.append(
          'sections',
          drawer
            .getSectionsToRender()
            .map((section) => section.id)
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        if (
          typeof drawer.setActiveElement === 'function'
        ) {
          drawer.setActiveElement(
            document.activeElement
          );
        }
      }


      config.body =
        formData;


      const response =
        await fetch(
          routes.cart_add_url,
          config
        );


      const data =
        await response.json();


      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
          data.message ||
          'Geschenk konnte nicht hinzugefügt werden.'
        );
      }


      if (
        drawer &&
        typeof drawer.renderContents === 'function'
      ) {
        drawer.renderContents(data);
      } else {
        window.location.assign(
          routes.cart_url
        );
      }


      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {
        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'nt-free-gift',
            productVariantId: variantId,
            cartData: data,
          }
        );
      }

    } catch (error) {
      console.error(
        '[NeverTap Free Gift]',
        error
      );

      setGiftButtonState(
        button,
        false
      );

      button.textContent =
        'Fehler – erneut versuchen';

      window.setTimeout(() => {
        setGiftButtonState(
          button,
          false
        );
      }, 1800);
    }
  }


  function updateGiftVariant(select) {
    const card =
      select.closest('[data-nt-gift-card]');

    if (!card) return;


    const option =
      select.options[
        select.selectedIndex
      ];


    const oldPrice =
      card.querySelector(
        '[data-nt-gift-old-price]'
      );


    if (oldPrice) {
      oldPrice.textContent =
        option.dataset.originalPrice || '';
    }
  }


  async function enforceFreeGiftEligibility() {
    if (enforcementRunning) return;


    const configElement =
      document.querySelector(
        '[data-nt-gift-config]'
      );

    if (!configElement) return;


    const threshold =
      Number(
        configElement.dataset
          .giftThresholdCents || 0
      );

    if (!threshold) return;


    enforcementRunning = true;


    try {
      const response =
        await fetch('/cart.js');


      const cart =
        await response.json();


      const freeGiftItems =
        cart.items.filter((item) => {
          return (
            String(
              item.properties?._nt_free_gift
            ) === 'true'
          );
        });


      if (!freeGiftItems.length) {
        return;
      }


      const qualifyingTotal =
        cart.items.reduce(
          (total, item) => {

            const isGift =
              String(
                item.properties?._nt_free_gift
              ) === 'true';


            if (isGift) {
              return total;
            }


            return (
              total +
              Number(
                item.final_line_price || 0
              )
            );
          },
          0
        );


      if (
        qualifyingTotal >= threshold
      ) {
        return;
      }


      const updates = {};


      freeGiftItems.forEach((item) => {
        updates[item.key] = 0;
      });


      const drawer =
        getDrawer();


      const body = {
        updates,

        sections:
          drawer &&
          typeof drawer.getSectionsToRender ===
            'function'
            ? drawer
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.id
                )
            : [
                'cart-drawer',
                'cart-icon-bubble',
              ],

        sections_url:
          window.location.pathname,
      };


      const updateConfig =
        fetchConfig();

      updateConfig.body =
        JSON.stringify(body);


      const updateResponse =
        await fetch(
          routes.cart_update_url,
          updateConfig
        );


      const updatedCart =
        await updateResponse.json();


      if (
        drawer &&
        typeof drawer.renderContents ===
          'function'
      ) {
        drawer.renderContents(
          updatedCart
        );
      }


      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !==
          'undefined'
      ) {
        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source:
              'nt-free-gift-enforcer',

            cartData:
              updatedCart,
          }
        );
      }

    } catch (error) {
      console.error(
        '[NeverTap Gift Eligibility]',
        error
      );

    } finally {
      enforcementRunning = false;
    }
  }


  /*
   * Nur Gift-Buttons behandeln.
   * Der normale Bundle-Upsell wird NICHT berührt.
   */
  document.addEventListener(
    'click',
    (event) => {

      const giftButton =
        event.target.closest(
          '[data-nt-gift-add]'
        );


      if (!giftButton) return;


      event.preventDefault();

      addFreeGift(
        giftButton
      );
    }
  );


  document.addEventListener(
    'change',
    (event) => {

      if (
        !event.target.matches(
          '[data-nt-gift-variant]'
        )
      ) {
        return;
      }


      updateGiftVariant(
        event.target
      );
    }
  );


  document.addEventListener(
    'DOMContentLoaded',
    () => {

      window.setTimeout(
        enforceFreeGiftEligibility,
        300
      );


      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !==
          'undefined'
      ) {

        subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {

            if (
              event.source ===
              'nt-free-gift-enforcer'
            ) {
              return;
            }


            window.setTimeout(
              enforceFreeGiftEligibility,
              150
            );

          }
        );
      }
    }
  );

})();